(function ($) {
    var mPhotoGalleryCardsObjectCounter = 0;

    $.widget("ui.SpotlightCards",
        {
            options:
            {
                LoadingHTML: '<div>'
                    + '<img src="/img/spacer.gif" alt="Loading Cards..." title="Loading Cards..."/>'
                    + '<div>Loading...</div>'
                    + '</div>',
                ErrorHTML: '<div>'
                    + '<img src="/img/spacer.gif" alt="Error Loading Cards." title="Error Loading Cards."/>'
                    + '<div>Error Loading Cards.</div>'
                    + '</div>',
                ResultSelector: '.fbcms_card',
                ResultListSelector: '.fbcms_cards',
                MasonrySelector: '.fbcms_contentbody.masonry',
                SkiplinksContainerSelector: '.fbcms_card_skiplinks',
                SkiplinkSelector: '.skiplink'
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _create: function ()
            {
                var self = this;
                var jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultSelector))
                {
                    FBUtilities.LogMessage('SpotlightCards - required settings null or empty.');
                    return;
                }

                self._InitMasonry();
                self.SetupCardButtons();
            },

            _InitMasonry: function ()
            {
                var self = this;
                var jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.MasonrySelector))
                {
                    return;
                }

                var lContainer = jElement.find(self.options.MasonrySelector);

                if (lContainer.length === 1)
                {
                    lContainer.masonry(
                        {
                            // options
                            itemSelector: self.options.ResultSelector,
                            columnWidth: self.options.ResultSelector
                        });
                }
            },

            SetupCardButtons: function ()
            {
                var self = this;
                var jElement = $(self.element);

                var lContainer = jElement.find(self.options.ResultListSelector);
                var lCards = lContainer.find(self.options.ResultSelector);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SkiplinksContainerSelector) === false
                    && FBUtilities.IsStringEmptyOrWhitespace(self.options.SkiplinkSelector) === false)
                {
                    $.each(
                        lCards,
                        function (aIndex, aValue)
                        {
                            var lCard = $(aValue);
                            lCard.find(self.options.SkiplinksContainerSelector).DropFocusManager(
                                {
                                    TitleOpenerSelector: self.options.SkiplinkSelector
                                    , DropLinksSelector: self.options.SkiplinkSelector
                                }
                            );
                        }
                    );
                }
            }
        });
        
    $( window ).on( 'load', function ()
    {
        $('.fbcms_spotlightcards').each(function()
        {
            if ($(this).SpotlightCards("instance") !== undefined)
            {
                $(this).SpotlightCards("destroy");
            }

            $(this).SpotlightCards();
        });
    } );

})(jQuery);
